import { Flex,Button,Box,Image, Text, Heading, Grid, GridItem } from '@chakra-ui/react';
import styled from '@emotion/styled';
import React,{useRef} from 'react';
import { MdOutlineFileDownload as DownloadIcon } from "react-icons/md";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useQuery } from 'react-query';
import apiCall from '../../../../utils/apiCall';
import { Loader } from '../../../../customs';
import { TranscriptAmount } from '../../Settings';
import { useAtom } from 'jotai';
import { openAtom,modalAtom,notificationAtom,openNAtom } from '../../../../context';

const daysOfWeek = [ 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ]; 
const monthOfYear = [
  'January',
  'Feburary',
  'March',
  'April',
  'May','June','July','August','September','October','November','December'
]

const Transcript = (props:any) => {
  const pdfRef = useRef<any>(null);
  const StudentNo = props?.StudentNo ;
  const Id = props?.Id ;
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_n_open] = useAtom(openNAtom)
  const [,set_notificaiton] = useAtom(notificationAtom)
 
  const { isLoading, data: transcript_detail } = useQuery(
  ['transcript-details', StudentNo, Id],
  {
    queryFn: async () =>
      await apiCall().post(
        `/Exam/transcriptTemplateDetails?studentNo=${StudentNo}&id=${Id}`
      ),

    select(data) {
      return data.data.Data;
    },

    onError(err: any) {
      set_open(false);
      set_notificaiton({
        type: 'error',
        message:
          err?.response?.data?.Message ||
          'This transcript cannot be generated, its either the result has not been completed or not processed',
      });
      set_n_open(true);
    },
  }
);

  
  const downloadPdf = () =>{
    const input = pdfRef.current;
    if(pdfRef && pdfRef.current){
   
      html2canvas(input).then(function (canvas) {

        var imgWidth = 210;
        var pageHeight = 290;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;
  
  
        var doc = new jsPDF('p', 'mm');
        var position = 0;
        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        var imgData = encodeURIComponent(pageData);
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        doc.setLineWidth(5);
        doc.setDrawColor(255, 255, 255);
        doc.rect(0, 0, 210, 295);
        heightLeft -= pageHeight;
  
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          doc.setLineWidth(5);
          doc.setDrawColor(255, 255, 255);
          doc.rect(0, 0, 210, 295);
          heightLeft -= pageHeight;
        }
        doc.save('transcript.pdf');
  
      });
    }
    
  }
  return (
    <>
    {!isLoading ?
      <Wrapper>
          <Flex justify="flex-end" mb="30px">
              <Button _hover={{bg:"var(--dark-green-color)"}} onClick={downloadPdf} bg="var(--dark-green-color)" color="var(--white-color)" leftIcon={<DownloadIcon />}>Download Transcript</Button>
          </Flex>
          <Box sx={{p:'20px 40px'}}  ref={pdfRef} >
            <Box minH="295mm">
              <Flex justify="flex-end" >
                <Image src={require('../../../../svg/cipm_transcript_logo.png')}
                    width="35%"
                />
              </Flex>
                <Text fontSize="20px">
                  {(new Date(transcript_detail?.TransciptGenerationDate))?.getDate()}, {monthOfYear[(new Date(transcript_detail?.TransciptGenerationDate))?.getMonth()]}, {(new Date(transcript_detail?.TransciptGenerationDate))?.getFullYear()}<br/>

                  {transcript_detail?.DestinationAddress}
                </Text>
                <Text m="15px 0">Dear Sir / Madam</Text>
                <Heading fontSize="20px">STATUS OF THE CIPM PROFESSIONAL DIPLOMA: {transcript_detail?.StudentName} (ACIPM) </Heading>
                <Text textAlign="justify" mt="20px" fontSize="20px">
                  We wish to inform you that the Chartered Institute of Personel Management of Nigeria was established in 1968. Through the instrumentation of <b>Act No. 58 of 1992,</b> the authority and power to regulate and control the profession of Personnel Management and Industrial Relations in Nigeria.<br></br><br></br>
                  The Institute runs a programme, which leads to its award of a Professional Diploma in Human Resources Management.<br></br> This programme consist of suits of studies across various subject areas (See attached transcript) in different stages and was taught, and examined in english Language, after which candidates undertake written examinations <br></br><br></br>
                  The minimum entry requirement for the Foundation stage is the West Africa School Certificate(WASC) or General Certificate of Education (GCE) O' Level with credit passes in five subjects, which must include English Language and Mathematics.  Increasingly, University Graduate in other Discipline who desire to enter the Personnel Management Profession are enrolling for this programmes. <br></br><br></br>
                  The minimum period the best of the candidates can spend in undertaking this programme is two years of intensive studies.<br></br><br></br>
                  We hope you will find the above information useful in according appropriate recognition to the holders of the <b>CIPM</b>  Professional Diploma.
                </Text>  
                <Heading fontSize="20px" m="20px 0 30px">Yours Faithfully</Heading>
                <Image 
                  w="200px"
                  src={require('../../../../svg/signature.png')}
                />
                <Heading fontSize="20px" mt="10px">
                  Mr, Gbenga Adetunde (ACIPM)<br/><br/>
                  Director, Professional Stardards and Develpment (PSD)
                </Heading>
                <Text textAlign="center" fontSize="18px" mt="50px">
                  CIPM House, 1 CIPM Avenue, Central Business District, Alausa, Ikeja, Lagos<br></br>
                  CIPM House, Plot 12,Benghazi Street, Wuse Zone 4, Abuja.<br></br>
                  <b>Tel:</b>  07001237555, <b>Email:</b>  info@cipmnigeria.org, <a href=" https://www.cipmnigeria.org" target='_blank'>www.cipmnigeria.org</a>  <br></br>
                  <b>PRESIDENT: </b> MR OLUSEGUN MOJEED, <b>FCIPM, VICE PRESIDENT:</b> MR HENRY UNUAKPOR, <b>MCIPM,  NATIONAL TREASURER:</b> MRS OGUCHUI<br></br>
                  <b>REGISTRAR CHIEF EXECUTIVE:</b> MS OLUWATOYOIN NAIWO. <b>FCIPM</b>
                </Text> 
                <Box mt="20px" height="20px" bg="var(--green-border-color)"></Box>
            </Box>
            <Box mt="160px">
              <Flex justify="flex-end">
                <Image src={require('../../../../svg/cipm_transcript_logo.png')}
                    width="35%"
                />
              </Flex>
                <Text>
                  {/* 13th September, 2023<br/>
                  New Brunswick Community College,<br/>
                  Saint John Campus,<br/>
                  950 Grandview Avenue,<br/>
                  Saint John, NBE214C5,<br/>
                  Canada */}
                  {transcript_detail?.DestinationAddress}
                </Text>
                <Heading fontSize="18px" mt="20px">
                  ACADEMIC RECORD OF {transcript_detail?.StudentName} (ACIPM)
                </Heading>
                <Text textAlign="justify" mt="20px">
                    We present the academic records of the above-mentioned Associate member of this Institute.<br></br>
                    He was admitted as a student in {new Date(transcript_detail?.StudentAdmissionDate)?.getFullYear()} and sat and passed the following papers between {new Date(transcript_detail?.StudentAdmissionDate)?.getFullYear()} and {new Date(transcript_detail?.StudentGraduationDate)?.getFullYear()}.
                  </Text>
                  <Grid >
                    {transcript_detail && transcript_detail.Levels?.length > 0?
                      transcript_detail?.Levels?.map((eLevel:any,ind:number)=><GridItem key={ind}>
                        <Flex margin="20px 0 10px" as={Heading} sx={{fontSize:'14px'}} justify="space-between">
                          <span style={{fontSize:'16px'}}>{eLevel.LevelName}</span>
                          <span style={{width:"150px",fontSize:'16px'}} >GRADE</span>
                        </Flex>
                        {eLevel.Subjects && eLevel.Subjects.length > 0 ?
                          eLevel.Subjects.map((eSubject:any,i:number) =><Flex justify="space-between" gap="20px" key={i}>
                            <span>{eSubject?.SubjectName}</span>
                            <span style={{marginLeft:'auto'}} >-</span>
                            <span style={{fontSize:'16px',width:'150px'}}>{eSubject.Grade}</span>
                          </Flex>)
                        :''}
                      </GridItem>)
                    :''}
                  </Grid>

                  <Heading fontSize="16px" m="20px 0 30px">Yours Faithfully</Heading>
                <Image 
                  w="200px"
                  src={require('../../../../svg/signature.png')}
                />
                <Heading fontSize="16px" mt="10px">
                  Mr, Gbenga Adetunde (ACIPM)<br/><br/>
                  Director, Professional Stardards and Develpment (PSD)
                </Heading>
                <Text sx={{float:'right'}} mt="-150px" w="150px">
                  <b>KEY RESULT</b><br/>
                  <b>A - DISTINCTION</b><br/>
                  <b>B - GOOD</b><br/>
                  <b>C - CREDIT</b><br/>
                  <b>P - PASS</b><br/>
                  <b>F - FAIL</b>
                </Text>
                <Text textAlign="center" mt="20px">
                  CIPM House, 1 CIPM Avenue, Central Business District, Alausa, Ikeja, Lagos<br></br>
                  CIPM House, Plot 12,Benghazi Street, Wuse Zone 4, Abuja.<br></br>
                  <b>Tel:</b>  07001237555, <b>Email:</b>  info@cipmnigeria.org, <a href=" https://www.cipmnigeria.org" target='_blank'>www.cipmnigeria.org</a> <br></br>
                  <b>PRESIDENT: </b> MR OLUSEGUN MOJEED, <b>FCIPM, VICE PRESIDENT:</b> MR HENRY UNUAKPOR, <b>MCIPM,  NATIONAL TREASURER:</b> MRS OGUCHUI<br></br>
                  <b>REGISTRAR CHIEF EXECUTIVE:</b> MS OLUWATOYOIN NAIWO. <b>FCIPM</b>
                </Text> 
                <Box mt="20px" height="20px" bg="var(--green-border-color)"></Box>                            
            </Box>
          </Box>
          

      </Wrapper>:
      <Loader />
    }
</>
  )
}

export default Transcript;



const Wrapper = styled.div`
    width:85vw;
`